import {Avatar} from './Avatar';
import {cn} from '../../lib/utils';

import type {AvatarProps} from './Avatar';

export interface AvatarWithOverlayProps {
  /** The primary avatar, e.g. an organisation logo. */
  avatar: AvatarProps;
  /** A smaller avatar pinned to the bottom-end corner, e.g. the signed-in user. Rendered at `sm` unless `size` is set. */
  overlay: AvatarProps;
  className?: string;
}

/** An avatar with a second, smaller avatar overlaid on its bottom-end corner. */
export function AvatarWithOverlay({avatar, overlay, className}: AvatarWithOverlayProps) {
  return (
    <div data-slot="avatar-with-overlay" className={cn('relative w-fit shrink-0', className)}>
      <Avatar {...avatar} />
      <Avatar
        size="sm"
        {...overlay}
        className={cn(
          'absolute -bottom-1 -end-1 ring-2 ring-background-surface',
          overlay.className
        )}
      />
    </div>
  );
}
